<ng-container *transloco="let t">
  <div class="breadcrumbs">
    @for (link of breadcrumbsContent;track link;let idx = $index) {
      <p class="small">
            <span (click)="navigateToBreadcrumbLink(idx)" class="breadcrumbs__link"
                  [ngClass]="{'last' : idx === (breadcrumbsContent?.length ?? 0) - 1}">
      {{ t(link.name) }}
    </span>
      </p>
    }
  </div>
</ng-container>
